import {
  Box,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Typography,
} from '@mui/material';
import { ageFromBirthdate } from 'utils/HelperFunctions';
import { Sex, PatientDetail, scoreCardTexts, CommonTexts } from 'locale/es';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import {
  setFirstWeightRegisterAction,
  setLastWeightRegisterAction,
} from 'redux/reducers/weightReducer';
import moment from 'moment';
import { useTextStyles } from 'resources/AppTexts';
import { initializeScoresByPatient } from 'redux/reducers/patientScoreReducer';
import { AppColors } from 'resources/AppColors';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ScoreboardIcon from '@mui/icons-material/Scoreboard';

const PatientDetails = () => {
  const patientDataObj = useSelector(({ patient }) => patient);
  const centerObject = useSelector(({ center }) => center);

  const { data: scoresByPatient } = useSelector(
    ({ scoresByPatient }) => scoresByPatient
  );

  const interventions = centerObject?.data?.businessPackage?.name;

  const textStyles = useTextStyles();

  // ? How do I make this component work without allTimePatientData
  const { allTimePatientData, firstWeightRegister, lastWeightRegister } =
    useSelector(({ weightData }) => weightData);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!firstWeightRegister) {
      dispatch(setFirstWeightRegisterAction());
    }
    if (!lastWeightRegister) {
      dispatch(setLastWeightRegisterAction());
    }
    dispatch(initializeScoresByPatient(patientDataObj.id));
  }, [firstWeightRegister, lastWeightRegister, allTimePatientData]);

  const calculateBMI = (weight, height) =>
    weight &&
    height &&
    (parseInt(weight) / (parseInt(height) / 100) ** 2).toFixed(2);

  const lastScore =
    scoresByPatient?.length > 0
      ? scoresByPatient.reduce((latest, score) => {
          return new Date(latest.creationDate) > new Date(score.creationDate)
            ? latest
            : score;
        }, scoresByPatient[0])
      : { value: 0 };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          gap: 4,
          mt: 2,
        }}>
        <TextField
          label={CommonTexts.CENTER}
          value={patientDataObj?.center?.name.toUpperCase()}
          variant='outlined'
          sx={{
            background: AppColors.WHITE,
            mb: 2,
            borderRadius: 2,
            flexGrow: 2,
          }}
        />
        <TextField
          label={PatientDetail.INTERVENTION}
          value={
            interventions
              ? interventions.toUpperCase()
              : PatientDetail.INTERVENTION_ERROR
          }
          variant='outlined'
          sx={{
            background: AppColors.WHITE,
            mb: 2,
            borderRadius: 2,
            flexGrow: 2,
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
        }}>
        <Card sx={{ m: 2, width: '25%' }}>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <AccountBoxIcon
              sx={{
                fill: AppColors.PRIMARY,
                width: '28.8px',
                height: '36px',
                ml: 1,
                mt: 2,
              }}
              data-cy='content'
            />
            <CardHeader
              title={PatientDetail.TITLE}
              titleTypographyProps={{ className: textStyles.subtitle_bold }}
              sx={{ mb: -2, ml: -1 }}
            />
          </Box>
          <CardContent>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant='body' component='div' sx={{ mb: 0.5 }}>
                <strong>{PatientDetail.AGE}:</strong>{' '}
                {patientDataObj.birthDay
                  ? ageFromBirthdate(patientDataObj.birthDay)
                  : '-'}
              </Typography>
              <Typography variant='body' sx={{ mb: 0.5 }}>
                <strong>{PatientDetail.INTIALWEIGHT}:</strong>{' '}
                {firstWeightRegister?.value
                  ? `${firstWeightRegister.value} kg el ${moment(
                      firstWeightRegister.timestamp
                    ).format('DD/MM/YYYY')}`
                  : '-'}
              </Typography>
              <Typography variant='body' sx={{ mb: 0.5 }}>
                <strong>{PatientDetail.LASTWEIGHT}:</strong>{' '}
                {lastWeightRegister?.value
                  ? `${lastWeightRegister.value} kg el ${moment(
                      lastWeightRegister.timestamp
                    ).format('DD/MM/YYYY')}`
                  : '-'}
              </Typography>
              <Typography variant='body' component='div' sx={{ mb: 0.5 }}>
                <strong>{Sex.SEX}:</strong>{' '}
                {Sex[patientDataObj.sex] ? Sex[patientDataObj.sex] : '-'}
              </Typography>
              <Typography variant='body' component='div' sx={{ mb: 0.5 }}>
                <strong>{PatientDetail.BMI}:</strong>{' '}
                {calculateBMI(lastWeightRegister?.value, patientDataObj.height)}
              </Typography>
              <Typography variant='body' component='div'>
                <strong>{PatientDetail.HEIGHT}:</strong>{' '}
                {patientDataObj.height ? `${patientDataObj.height} cm` : '-'}
              </Typography>
            </Box>
          </CardContent>
        </Card>
        <Card sx={{ p: 0, m: 2, width: '25%' }}>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <ScoreboardIcon
              sx={{
                fill: AppColors.PRIMARY,
                width: '28.8px',
                height: '36px',
                ml: 2,
                mt: 2,
              }}
              data-cy='content'
            />
            <CardHeader
              title={scoreCardTexts.LAST_SCORE}
              titleTypographyProps={{ className: textStyles.subtitle_bold }}
              sx={{ mb: -2 }}
            />
          </Box>
          <CardContent
            sx={{
              mt: 5,
              fontSize: '50px',
              display: 'flex',
              justifyContent: 'center',
              color: AppColors.PRIMARY,
            }}>
            {lastScore?.value}
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default PatientDetails;
